import * as React from "react";
import { Link } from "react-router-dom";
import "../../../../assets/scss/components/toc/orderPlacement/opOrderStatus/opOrderStatus.scss";

export interface IOpOrderStatusProps {
	isSip?: boolean; // if true, then 'SIP Order Placed' else 'Order Placed Successfully'
	ordNo: string; // order number
	ordStsUrl: string;
	posUrl: string;
	placeOrdUrl: string;
}

const OpOrderStatus: React.FC<IOpOrderStatusProps> = props => {
	return (
		<section className="op_order_status">
			<div className="icon"><i className="edel-icon-tick"></i></div>
			{props.isSip ? <h1 className="success_msg">SIP Order Placed</h1> : <h1 className="success_msg">Order Placed Successfully</h1>}
			<p className="ord_no">Order no: {props.ordNo}</p>

			<div className="help_links">
				<Link to={props.ordStsUrl} className="link_cont">
					<span className="link_name">Order Status</span>
					<i className="edel-icon-arrow-right"></i>
				</Link>
				<Link to={props.posUrl} className="link_cont">
					<span className="link_name">Positions</span>
					<i className="edel-icon-arrow-right"></i>
				</Link>
				<Link to={props.placeOrdUrl} className="link_cont">
					<span className="link_name">Place Order</span>
					<i className="edel-icon-arrow-right"></i>
				</Link>
			</div>
		</section>
	);
};

export default OpOrderStatus;
